const adminRoutes = [
  {
    path: '/admin/',
    redirect: { name: 'super-admin-tenants' },
    meta: { layout: 'admin', superAdmin: true }
  },
  {
    path: '/admin/tenants',
    name: 'super-admin-tenants',
    component: () =>
      import(
        /* webpackChunkName: "super-admin-tenants" */ '@/views/super-admin/TenantPanel.vue'
      ),
    meta: { layout: 'admin', superAdmin: true }
  }
];

export default adminRoutes;
